/**
 * The Operations Hub's hours to the next MR, each aircraft (MB's R239; docs/specs/portal/operations-hub.md §21): the
 * figure, state word and colours of Teslyn Field's Fuel and maintenance page, those needing attention first. Rules
 * and words: `@teslyn/domain` `fleetMr`, `MR_STATE_WORD`, `MR_STATE_QC`.
 */
import type { ReactElement } from 'react';
import { MR_STATE_QC, MR_STATE_WORD, mrHoursWords, type FleetMrRow } from '@teslyn/domain';

const CHIP: Readonly<Record<(typeof MR_STATE_QC)[keyof typeof MR_STATE_QC], string>> = {
  pass: 'chip chip--pass',
  warn: 'chip chip--warn',
  fail: 'chip chip--fail',
  pending: 'chip',
};

export function HubMrList({
  rows,
}: {
  /** The rows, the words of a failed read, or null while loading. */
  readonly rows: readonly FleetMrRow[] | string | null;
}): ReactElement {
  return (
    <section className="hub-mr" aria-label="Hours to next MR">
      <h3 className="label hub-mr__title">Hours to next MR</h3>
      {rows === null && <p className="caption muted">Loading the aircraft…</p>}
      {typeof rows === 'string' && <p className="caption">Could not load the MR hours: {rows}</p>}
      {Array.isArray(rows) && rows.length === 0 && <p className="caption muted">No aircraft yet.</p>}
      {Array.isArray(rows) && rows.length > 0 && (
        <ul className="hub-mr__list">
          {(rows as readonly FleetMrRow[]).map((r) => (
            <li key={r.aircraft_id} className="caption hub-mr__row">
              <span className="data">{r.registration}</span>
              <span className="muted">{r.project_number ? `on ${r.project_number}` : 'no flights yet'}</span>
              <span className="data hub-mr__hours">{mrHoursWords(r.remaining_h)}</span>
              <span className={`${CHIP[MR_STATE_QC[r.state]]} label`}>{MR_STATE_WORD[r.state]}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
